module.exports = __webpack_public_path__ + "img/Accountor-44-lowres.73e09112.jpg";